import React from 'react';
import styled from 'styled-components';
import { useNavigate } from '@reach/router';
import { GridContainer, Formatted, Heading } from '@agilytics/components';
import content from './content.json';
import imgError from './error.png';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.spacingTriple};
  padding: 0px ${({ theme }) => theme.spacingTriple};
`;

const Image = styled.img`
  max-width: 600px;
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrnitap;
  margin-top: ${({ theme }) => theme.spacingTriple};
  text-align: center;
  max-width: 600px;
  width: 100%;
`;

const BackLink = styled.button`
  background: none;
  color: ${({ theme }) => theme.colors.brand};
  border: none;
  padding: 0;
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: ${({ theme }) => theme.fontSizes.paragraph};
  cursor: pointer;
  outline: inherit;
  text-decoration: underline;
  margin-top: ${({ theme }) => theme.spacingBase};
`;

const StyledA = styled(BackLink)`
  margin-top: ${({ theme }) => theme.spacingDouble};
  font-size: ${({ theme }) => theme.fontSizes.legal};
`;

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <GridContainer>
      <Container>
        <Image src={imgError} alt={content.title} />
        <TextContainer>
          <Heading level={2}>{content.title}</Heading>
          <Formatted content={content.content} />
          <BackLink onClick={() => navigate('/')}>{content.backText}</BackLink>
          <StyledA href="https://status.atlassian.com" target="_blank" rel="noopener noreferrer">
            {content.statusPageText}
          </StyledA>
        </TextContainer>
      </Container>
    </GridContainer>
  );
}
